import { config } from '../config';

export async function callGetFeatureJson(idLayer, idFeature) {
  let headers = new Headers();
  var url = new URL(`${config.url.JSON_FEATURE_URL}/${idLayer}/${idFeature}`);
  const response = await fetch(url, {
    method:'GET',
    headers: headers
  });
  return response.json();
}

export async function callGetFeatureJsonByRadius(idLayer, lon, lat, radius) {
  let headers = new Headers();
  var url = new URL(`${config.url.JSON_FEATURE_URL}/${idLayer}/?lon=${lon}&lat=${lat}&radius=${radius}`);
  const start = (new Date()).getTime();
  const response = await fetch(url, {
    method:'GET',
    headers: headers
  });
  const end = (new Date()).getTime();
  if (response.status == 200) {
    return {query : response.json() , time : end - start};
  } else {
    throw new Error('The query didn\'t return a 200 http status code ');
  }
  
}

export async function callPostSearchQuery(layers, lon, lat, radius) {
  let headers = new Headers();
  headers.append('content-type', 'application/json');
  var url = new URL(`${config.url.JSON_FEATURE_URL}/search`);
  const payload = {
    lon: lon,
    lat: lat,
    radius: radius,
    layers: layers
  };
  const start = (new Date()).getTime();
  const response = await fetch(url, {
    method:'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });

  const end = (new Date()).getTime();
  if (response.status == 200) {
    return {query : response.json() , time : end - start};
  } else {
    throw new Error('The query didn\'t return a 200 http status code ');
  }
  
}